module.exports = __webpack_public_path__ + "kluebot-e0e1a04eb28a559ecf0b162ecbb3f5d0.png";